import { Autocomplete } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { StyledTextField } from '../TextInput/TextInput';

interface AutoCompleteProps {
  id: string;
  label: string;
  options: string[];
  value: string;
  required?: boolean;
  disabled?: boolean;
  // Shows "Loading…" in the open list while the options are being fetched
  loading?: boolean;
  onChange: (_: React.SyntheticEvent, value: string | null) => void;
  style?: SxProps<Theme>;
}

const AutoComplete = ({
  id,
  label,
  options,
  value,
  onChange,
  required = false,
  disabled = false,
  loading = false,
  style,
}: AutoCompleteProps) => {
  return (
    <Autocomplete
      disablePortal
      id={id}
      // An empty string means nothing is selected; MUI expects null for that
      value={value || null}
      options={options}
      onChange={onChange}
      disabled={disabled}
      loading={loading}
      fullWidth
      sx={style}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          label={label}
          required={required}
          slotProps={{
            ...params.slotProps,
            inputLabel: { ...params.slotProps.inputLabel, shrink: true }
          }}
        />
      )}
    />
  );
};

export default AutoComplete;